<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4>Packages</h4>
            <button @click="newPackage"
                    :disabled="loading"
                    class="btn btn-primary">
                New package
            </button>
        </div>
        <VueGoodTable :columns="columns"
                      :rows="packages"
                      @on-row-click="viewPackage"
                      :isLoading.sync="loading"
                      :pagination-options="{
                        enabled: true,
                      }"
                      styleClass="vgt-table condensed"
                      class="vgt-table--card"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VueGoodTable } from 'vue-good-table';

export default {
  components: {
    VueGoodTable,
  },
  computed: {
    ...mapGetters({
      packages: 'packages/productPackages',
    }),
  },
  data() {
    return {
      loading: false,
      columns: [],
    };
  },
  mounted() {
    this.columns = [
      {
        label: 'Name',
        field: 'name',
        filterOptions: {
          enabled: true,
        },
      },
    ];
    this.getProductPackages();
  },
  methods: {
    newPackage() {
      this.$router.push({
        name: 'package',
        params: { id: 'new' },
      });
    },
    getProductPackages() {
      this.loading = true;

      this.$store.dispatch('packages/getProductPackages')
        .finally(() => {
          this.loading = false;
        });
    },
    viewPackage(event) {
      this.$router.push({
        name: 'package',
        params: { id: event.row.id },
      });
    },
    updateParams(props) {
      this.$store.commit('packages/queryProps', props);
    },
  },
};
</script>
